module.exports = __webpack_public_path__ + "../static/img/canon_mini.613ad19e.png";